<template>
  <div class="relative">
      <div class="flex items-center" @mouseover="showTooltip" @mouseout="hideTooltip" @click="toggleTooltip">
          <slot name="tipTrigger"></slot>
      </div>
      <div v-if="tooltipVisible" @mouseover="showTooltip" @mouseout="hideTooltip" class="absolute z-50 pointer-events-none" :class="classes">
        <div class="text-sm mt-1 p-1 text-grey-dark bg-white border-grey-xlight border-1 rounded shadow-lg ">
          <slot name="tipText"></slot>              
        </div>
      </div>
  </div>
</template>

<script setup>
    const props = defineProps({
        data: {
            type: [Object, String],
            default: '',
        },
        width:{
            type: String,
            default:'',
        },
        align: {
            type: String,
            default: '',
        }
    })

    const classes = computed(() => [
        props.width ? props.width : 'w-40',
        props.align ? props.align : 'right-0'
    ].join(' '));

    const tooltipVisible = ref(false);

    const showTooltip = () => tooltipVisible.value = true;
    const hideTooltip = () => tooltipVisible.value = false;
    const toggleTooltip = () => tooltipVisible.value = !tooltipVisible.value;
</script>

